import { Card, Row, Col } from "react-bootstrap";
import { useGetClientSummaryDetails } from "../hooks/useGetClientSummaryDetails";
import Skeleton from "react-loading-skeleton";
import { useClientContext } from "../../../hooks/ClientContext";
import useOpenMasterAccount from "../../../hooks/useOpenMasterAccount";
import ClientDetailsGrid from "./ClientDetailsGrid";
import moment from "moment";
import { ThemedParagraph, ThemedSpan } from "../../../components/utilities";
import { useGetFactFindSummaryDetails } from "../hooks/useGetFactFindSummaryDetails";

function AccountSummaryDetails() {
    const { data: clientSummaryData, error: clientSummaryError, isLoading: clientSummaryIsLoading } = useGetClientSummaryDetails();
    const { data: factFindData, error: factFindError, isLoading: factFindIsLoading } = useGetFactFindSummaryDetails();
    const { id: masterAccountId } = useClientContext();
    const openMasterAccount = useOpenMasterAccount();

    if (clientSummaryIsLoading || factFindIsLoading) return (
        <Skeleton height={300} />
    )

    if (clientSummaryError || factFindError) {
        return <p>Error loading data</p>;
    }

    if (!clientSummaryData || !factFindData) {
        return null;
    }

    const handleOpenClientDetails = (e) => {
        e.preventDefault();
        openMasterAccount(masterAccountId, { suffix: "details" });
    };

    const defaultNumber = clientSummaryData.defaultFax
        ? clientSummaryData.defaultFax.details
        : clientSummaryData.defaultPhone
            ? clientSummaryData.defaultPhone.details
            : <ThemedSpan style={{ color: "red" }}>Not Set</ThemedSpan>;

    const defaultNumberLabel = clientSummaryData.defaultFax
        ? "Default Fax No.:"
        : clientSummaryData.defaultPhone
            ? "Default Phone No.:"
            : "Default No.:";

    return (
        <>
            <Col xs={12} sm={12} md={9} lg={9} xl={9}>
                <Card style={{ height: "auto", minHeight: "300px" }}>
                    <Card.Body className="position-relative">
                        <Card.Title style={{ fontSize: "18px", paddingBottom: "20px" }}><a className="text-reset text-decoration-none" href={`/client/${masterAccountId}/details`}
                            onClick={(e) => handleOpenClientDetails(e)}>
                            <ThemedSpan variant="primary" className="fw-bold">Account Details</ThemedSpan>
                        </a>
                        </Card.Title>
                        <Card.Text as="div">
                            <Row>
                                <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <Row>
                                        <Col className="col-4">
                                            <p><ThemedSpan variant="primary">Account Type:</ThemedSpan></p>
                                        </Col>
                                        <Col className="col-8">
                                            {clientSummaryData.accountType}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-4">
                                            <p><ThemedSpan variant="primary">Adviser:</ThemedSpan></p>
                                        </Col>
                                        <Col className="col-8">
                                            {clientSummaryData.adviser && (<p>{clientSummaryData.adviser.displayName}</p>)}
                                            {!clientSummaryData.adviser && (<p>-</p>)}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-4">
                                            <p><ThemedSpan variant="primary">Address: </ThemedSpan></p>
                                        </Col>
                                        <Col className="col-8">
                                            {clientSummaryData.addresses.map((item, i) => (
                                                <div key={i}>
                                                    <p>
                                                        {item.address}, {item.postcode}
                                                    </p>
                                                </div>
                                            ))}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-4">
                                            <p><ThemedSpan variant="primary">Fact Find last verified by: </ThemedSpan></p>
                                        </Col>
                                        <Col className="col-8">
                                            <p>{factFindData.lastVerifiedByName ? <span>{factFindData.lastVerifiedByName} ({moment(factFindData.lastVerifiedDate).format('DD/MM/YYYY')})</span> : <span style={{ color: 'red' }}>Not Verified</span>}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-4">
                                            <p><ThemedSpan variant="primary">Fact Find last archived by:</ThemedSpan></p>

                                        </Col>
                                        <Col className="col-8">
                                            <p>{factFindData.lastArchivedByName ? <span>{factFindData.lastArchivedByName} ({moment(factFindData.lastArchivedDate).format('DD/MM/YYYY')})</span> : <span style={{ color: 'red' }}>Not Verified</span>}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <Row>
                                        <Col className="col-4">
                                            <p><ThemedSpan variant="primary">Default Email Address:</ThemedSpan></p>

                                        </Col>
                                        <Col className="col-8">
                                            {clientSummaryData.defaultEmail ? (<p>{clientSummaryData.defaultEmail.details}</p>) : <p style={{ color: "red" }}>Not Set</p>}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-4">
                                            <ThemedParagraph variant="primary">{defaultNumberLabel}</ThemedParagraph>
                                        </Col>
                                        <Col className="col-8">
                                            <p>{defaultNumber}</p>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="pt-2">
                                <Col className="col-md-12 col-sm-12 px-2">
                                    <ClientDetailsGrid />
                                </Col>
                            </Row>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        </>
    )
}

export default AccountSummaryDetails;